<template>
	<v-app id="zarinpalCallback-view" fluid tag="section">
		<v-app-bar color="secondary" dark dense style="max-height: 48px">
			<a href="/" class="d-flex align-center">
				<img src="/logo-wide.png" style="max-width: 80px; max-height: 32px" class="hidden-sm-and-down" />

				<!-- نسخه کوچکتر برای موبایل -->
				<img src="/logo-wide.png" style="max-width: 60px; max-height: 28px" class="hidden-md-and-up" />
			</a>
			<div class="">
				<strong>اعتبارسنجی و پردازش پرداخت آنلاین</strong>
				&nbsp;&nbsp;
				<span class="warning--text text-truncate">{{ longTitle }}</span>
			</div>
		</v-app-bar>
		<v-container>
			<v-row align="center" justify="center">
				<v-col cols="10" md="6">
					<v-card ref="card" class="mx-auto my-12">
						<div class="d-flex flex-column justify-center align-center" style="height:200px;" :style="{ 'background-color': bg }">
							<v-icon size="large" :color="color" style="font-size: 100px;">
								{{ icon }}
							</v-icon>
							<p :style="{ color: color }">{{ title }}</p>
						</div>
						<div class="form-group text-center py-5">
							<div v-if="msg" v-html="msg">

							</div>
							<p v-if="!success" class="grey--text px-5 pt-10"><small>در صورت کسر وجه٬ تراکنش به طور
									خودکار و حداکثر تا ۷۲ ساعت به حساب شما بازگشت داده ميشود. در صورت بروز مشکل پس از زمان مذکور با ما تماس
									بگيريد.</small></p>
						</div>
						<v-card-actions class="my-10">
							<v-spacer />
							<v-btn ref="submit" color="secondary" dark @click="returnToPanel()">
								بازگشت به پنل کاربری
							</v-btn>
							<v-spacer />
						</v-card-actions>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</v-app>
</template>

<script>
import { get } from 'vuex-pathify'
import ThemeManager from '@/util/theme-manager.js'

export default {
	name: 'SadadMemebrCallback',
	data() {
		return {
			success: null,
			msg: null,
		}
	},
	computed: {
		...get('siteConfig', [
			'longTitle'
		]),
		bg() {
			if (this.success)
				return 'rgb(182 255 193)'
			return 'rgb(255 227 227)'
		},
		color() {
			if (this.success)
				return '#0dd400'
			return '#ff5722'
		},
		icon() {
			if (this.success)
				return 'mdi-credit-card-check'
			return 'mdi-alert-circle-outline'
		},
		title() {
			if (this.success)
				return 'پرداخت موفق'
			return 'پرداخت ناموفق'
		}
	},
	created() {
		ThemeManager.ApplyThemeSettings(this.$route.params.customerCode || 0, this.$vuetify)
	},
	mounted() {
		this.success = this.$route.query.success
		this.msg = this.$route.query.msg
	},
	methods: {
		returnToPanel() {
			this.$router.push('/member/dashboard')
		}
	},
}
</script>

<style scoped></style>
